'use client';

import { useEffect } from 'react';
import { CWITNESSCARDMODAL_BODY_OVERFLOW_HIDDEN } from './cwitnesscardmodalConstants';

export function useCwitnesscardmodalEffects(onClose: () => void): void {
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = CWITNESSCARDMODAL_BODY_OVERFLOW_HIDDEN;
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onClose]);
}
